import type { Draft } from 'immer';
import { useImmer } from 'use-immer';
import useConstant from 'use-constant';

export default function useTourEditing<S>(
  initialState = {} as S,
  defaultState = {} as Partial<S>
): {
  state: S;
  setState: (f: (draft: Draft<S>) => void | S) => void;
  isChanged: boolean;
  defaultState: Partial<S>;
} {
  const [state, setState] = useImmer<S>(
    (): S => ({ ...defaultState, ...initialState })
  );
  const firstState = useConstant(() => state);
  const isChanged = firstState !== state;
  return { state, setState, isChanged, defaultState };
}
